export {
    getShouldOpenFeedbackWidget,
    getShowTypeField,
    getAdditionalFields,
    getCustomComponent,
} from './feedback-collector';
